import 'react-phone-number-input/style.css';
import styles from './style.module.css';
import PhoneInput from 'react-phone-number-input';

interface IInputInternational {
  hookForm?: any;
  onChange?: any;
  errors?: any;
  value?: any;
}

export function InputInternational({
  hookForm,
  onChange,
  errors,
  value,
}: IInputInternational) {
  return (
    <>
      <PhoneInput
        placeholder="Número de telefone"
        onChange={onChange}
        {...hookForm}
        className={styles.input}
        value={value}
      />
      <span className="tiny-text text-danger">
        {errors.phone ? 'Obrigatório' : ''}
      </span>
    </>
  );
}
